import { render, staticRenderFns } from "./CreateRoomAvatar.vue?vue&type=template&id=420a2ba7&"
import script from "./CreateRoomAvatar.vue?vue&type=script&lang=js&"
export * from "./CreateRoomAvatar.vue?vue&type=script&lang=js&"
import style0 from "./CreateRoomAvatar.vue?vue&type=style&index=0&id=420a2ba7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VIcon,VImg})
